export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const DESELECT_PRODUCT = 'DESELECT_PRODUCT';
export const SELECT_ALL_PRODUCTS = 'SELECT_ALL_PRODUCTS';
export const DESELECT_ALL_PRODUCTS = 'DESELECT_ALL_PRODUCTS';
